<template>
    <div>
        <div v-if="reportData && reportData.data && reportData.data.length !== 0" id="data-list-list-view" class="data-list-container">
            <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="reportData.data">
              <template slot="thead">
                  <vs-th v-for="(col, index) in reportData.columns" :key="index" :sort-key="col.toLowerCase().split(' ').join('-')" class="items-center">{{ col }}</vs-th>
              </template>
              <template slot-scope="{data}">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td v-for="(col, indexCol2) in reportData.columns" :key="indexCol2" class="items-center">
                            <p v-if="String(tr[col]) !== 'true' && String(tr[col]) !== 'false'" class="product-name font-medium truncate">{{ tr[col] }}</p>
                            <div v-else-if="String(tr[col]) === 'true'">
                              <feather-icon icon="CheckCircleIcon" svgClasses="text-primary stroke-current w-5 h-5" />
                            </div>
                            <div v-else>
                              -
                            </div>
                        </vs-td>
                    </vs-tr>
                </tbody>
              </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
export default {
  props: ['reportData'],
  data() {
      return {
        itemsPerPage: 25,
        selected: [],
      }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
          justify-content: center;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
